// extracted by mini-css-extract-plugin
export var box = "SliderControl-module--box--4bc19";
export var box_md = "SliderControl-module--box_md--c05d0";
export var box_xmd = "SliderControl-module--box_xmd--8af1b";
export var box_flex = "SliderControl-module--box_flex--54915";
export var box_lg = "SliderControl-module--box_lg--daafa";
export var box_sm = "SliderControl-module--box_sm--53542";
export var box_outer = "SliderControl-module--box_outer--169bf";
export var box_whiteBg = "SliderControl-module--box_white-bg--7e4dc";
export var box_noMarginBottom = "SliderControl-module--box_no-margin-bottom--8b89f";
export var box_noPadding = "SliderControl-module--box_no-padding--51e2a";
export var box_outerGray = "SliderControl-module--box_outer-gray--ec764";
export var box_dark = "SliderControl-module--box_dark--1ea57";
export var box_zIndex = "SliderControl-module--box_z-index--3556a";
export var box_zIndex6 = "SliderControl-module--box_z-index-6--0d3b7";
export var box_eventsWithLine = "SliderControl-module--box_events-with-line--4f3e0";
export var box_featuresAo = "SliderControl-module--box_features-ao--8c377";
export var box_verticalPaddings = "SliderControl-module--box_vertical-paddings--9d185";
export var clearP = "SliderControl-module--clearP--611d9";
export var clearP_vc = "SliderControl-module--clearP_vc--4a051";
export var buttonsWrapper = "SliderControl-module--buttonsWrapper--74bc2";
export var text = "SliderControl-module--text--ac069";
export var white = "SliderControl-module--white--3a528";
export var nextButton = "SliderControl-module--nextButton--632f5";
export var fadeInAnimation = "SliderControl-module--fadeInAnimation--a0d78";
export var placeHolderShimmer = "SliderControl-module--placeHolderShimmer--17dca";